import { _fetch as fetchSecure } from '@hobs/utils/fetch';

import {
  FORSUBMIT,
  GET,
  CREATE,
  UPDATE,
  CLEAR,
  CHANGEPASSWORD,
  RESENDRESETPASSWORD,
  CHANGELOCKSTATUS
} from '@hobs/constants/users';

export function getUserForSubmit() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('users/forSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FORSUBMIT.REQUEST };
  }
  function success(response) {
    return { type: FORSUBMIT.SUCCESS, response };
  }
  function failure(error) {
    return { type: FORSUBMIT.FAILURE, error };
  }
}

export function createUser(user) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('users', { body: user, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success() {
    return { type: CREATE.SUCCESS };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function getUser(userId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`users/${userId}`)
      .then(response => {
        if (response.payload) {
          dispatch(success(response.payload));
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function updateUser(user) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('users', { body: user, method: 'PUT' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: UPDATE.REQUEST };
  }
  function success() {
    return { type: UPDATE.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function changePassword(userId, password) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`users/${userId}/ChangePassword`, {
      body: password,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: CHANGEPASSWORD.REQUEST };
  }
  function success() {
    return { type: CHANGEPASSWORD.SUCCESS };
  }
  function failure(error) {
    return { type: CHANGEPASSWORD.FAILURE, error };
  }
}

export function resendResetPassword(userId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`users/${userId}/ResendResetEmail`, { method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: RESENDRESETPASSWORD.REQUEST };
  }
  function success() {
    return { type: RESENDRESETPASSWORD.SUCCESS };
  }
  function failure(error) {
    return { type: RESENDRESETPASSWORD.FAILURE, error };
  }
}

export function changeLockStatus(userId, lockStatus) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`users/${userId}/changeLockStatus`, {
      body: lockStatus,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: CHANGELOCKSTATUS.REQUEST };
  }
  function success() {
    return { type: CHANGELOCKSTATUS.SUCCESS };
  }
  function failure(error) {
    return { type: CHANGELOCKSTATUS.FAILURE, error };
  }
}

export function clearUser() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}
